define(function () {
  return /^margin/;
});